import downloadFile from '@/helpers/download-file'
import {calcPercentFromSum, calcSumFromPercent, loadTimeFields, saveTimeFields} from '@/helpers/lot-helpers'
import common from './common';

export default {
    namespaced: true,
    state: {
        ...common.state,
    },
    mutations: {
        ...common.mutations,
    },
    actions: {
        ...common.actions,
        fetchPublicLot: ({commit}, id) => {
            commit("loadingProcess");
            commit("removeError");
            commit("setData", {
                id
            });
            let url = "lots/" + id;
            return axios
                .get(url)
                .then(res => {
                    let data = res.data.success
                    loadTimeFields(data)

                    commit("setRawData", data ?? {});
                    commit("setLotDocuments", res.data.lotDocuments ?? []);
                    commit("setUserLotRequest", res.data.request ?? {});
                    commit("setLotRequestFiles", res.data.requestFiles ?? []);
                    commit("setCanCreateRequest", res.data.canCreateRequest);
                    commit("setCantCreateRequestDescription", res.data.cantCreateRequestDescription);
                    commit("setUserLotParticipate", res.data.userLotParticipate);
                    commit("setLotRequestPriceOffer", res.data.requestPriceOffer);
                    commit("removeError");
                })
                .catch(err => {
                    commit("setError", err.response?.data?.message ?? err.message ?? "Неизвестная ошибка");
                })
                .finally(() => commit("loadingCompleted"));
        },
        fetchLotInternal: ({commit}, id) => {
            return axios
                .get(`admin/lots/${id}`)
                .then(res => {
                    loadTimeFields(res.data.success)
                    commit("setData", res.data.success ?? {});
                    commit("setCanUpdate", res.data.success?.can_update);
                    commit("setLotRequestLogs", res.data.success?.lot_request_logs ?? []);
                    commit("setLotDocuments", res.data.lotDocuments ?? []);
                    commit("setLotRequests", res.data.success?.lot_requests ?? []);
                    commit("removeError");
                })
                .catch(err => {
                    commit("setError", err.response?.data?.message ?? err.message ?? "Неизвестная ошибка");
                })
        },

        fetchRequestFiles: ({commit, state}, userId) => {
            commit("setLotRequestFiles", []);
            return axios
                .get(`admin/auctions/${state.data.id}/${userId}/files`)
                .then(res => {
                    commit("setLotRequestFiles", res.data.success);
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
                });
        },
        fetchRequestPriceOffer: async ({commit, state}, userId) => {
            commit("setLotRequestPriceOffer", null);
            try {
                const res = await axios.get(`admin/auctions/${state.data.id}/${userId}/priceOffer`)
                commit("setLotRequestPriceOffer", res.data.success);
            } catch (err) {
                commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
            }
        },

        downloadLotRequestReport: ({commit, state}, data) => {
            let url = `/api/admin/auctions/${state.data.id}/downloadRequestReport`;
            downloadFile(url, data.token)
        },
        downloadRequestFile: ({commit, state}, data) => {
            const {userId, fileId, token} = data;
            const url = `/api/admin/auctions/${state.data.id}/${userId}/files/${fileId}`;
            downloadFile(url, token);
        },
        create: ({commit}, formData) => {
            commit("loadingProcess");

            const data = {...formData}
            saveTimeFields(data)
            if (Number(data['percent_deposit_price']) === 1) {
                data['deposit_price'] = calcSumFromPercent(data['start_price'], data['deposit_price'])
            }
            if (Number(data['percent_step']) === 1) {
                data['step'] = calcSumFromPercent(data['start_price'], data['step'])
            }

            return axios
                .post("/admin/lots", data)
                .then(res => {
                    commit("setData", res.data.success);
                    commit("removeError");
                    commit("setSaveError", null)
                })
                .catch(err => {
                    let errors;
                    if(err.response?.data?.errors) {
                        errors = Object.values(err.response?.data?.errors).flat();
                    }
                    commit("setSaveError", errors || err.response?.data?.message || err.message || "Неизвестная ошибка");
                })
                .finally(() => commit("loadingCompleted"));
        },
        update: ({commit, dispatch, state}, formData) => {
            commit("loadingProcess");
            commit("setSaveError", null);

            const data = {...formData}
            saveTimeFields(data)

            if (Number(data['percent_deposit_price']) === 1) {
                data['deposit_price'] = calcSumFromPercent(data['start_price'], data['deposit_price'])
            }
            if (Number(data['percent_step']) === 1) {
                data['step'] = calcSumFromPercent(data['start_price'], data['step'])
            }
            let url = "/admin/lots/" + state.data.id;
            return axios
                .put(url, data)
                .then(res => {
                    return dispatch("fetchLot", state.data.id);
                })
                .catch(err => {
                    let errors;
                    if(err.response?.data?.errors) {
                        errors = Object.values(err.response?.data?.errors).flat();
                    }
                    throw errors || err.response?.data?.message || err.message || "Неизвестная ошибка";
                })
                .finally(() => commit("loadingCompleted"));
        },
        updatePriceOffer: ({commit}, file) => {
            commit('setLotRequestPriceOffer', file)
        },
        delete: ({commit, dispatch, state}) => {
            commit("loadingProcess");
            let url = "/admin/lots/" + state.data.id;
            return axios.delete(url).finally(() => commit("loadingCompleted"));
        },
        sendReceipt: ({dispatch, state, commit}, vm) => {
            commit("loadingProcess");
            let url = `/admin/lots/${state.data.id}/resendReceipt`;
            return axios.post(url)
                .catch(error => {
                    if (vm) {
                        vm.$bvToast.toast(error?.response?.data?.message ?? error.message ?? 'Неизвестная ошибка', {
                            title: "Не удалось отправить чек",
                            variant: "danger",
                        })
                    }
                }).then(res => {
                    if (vm) {
                        vm.$bvToast.toast(res.data.message, {
                            title: "Чек отправлен",
                            variant: "success",
                        })
                    }
                }).finally(() => {
                    dispatch("fetchLot", state.data.id);
                });
        },
        allowUser: ({commit, dispatch, state}, uid) => {
            commit("loadingRequests");
            let url = "/admin/auctions/" + state.data.id + "/allowUser";
            return axios
                .post(url, {id: uid})
                .finally(() => {
                    commit("loadingRequests", false)
                    dispatch("fetchRequests");
                });
        },
        /** data = {id: userId, reason: text} */
        disallowUser: ({commit, dispatch, state}, data) => {
            commit("loadingRequests");
            let url = "/admin/auctions/" + state.data.id + "/disallowUser";
            return axios
                .post(url, data)
                .finally(() => {
                    commit("loadingRequests", false)
                    dispatch("fetchRequests");
                });
        },
        /** data = {id: userId, reason: text} */
        documentDismiss: ({commit, dispatch, state}, data) => {
            commit("loadingProcess");
            let url = "/admin/auctions/" + state.data.id + "/documentDismiss";
            return axios
                .post(url, data)
                .then(res => {
                    return dispatch("fetchLot", state.data.id);
                })
                .catch(err => {
                    commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
                })
                .finally(() => commit("loadingCompleted"));
        },

        sendUserRequest: ({commit, dispatch, state}) => {
            const url = "lots/" + state.data.id + "/request";
            const data = {
                status: state.userLotRequest.status,
            };

            return axios
                .put(url, data)
                .then(response => {
                    commit("setUserLotRequest", response.data.request ?? {});
                    commit("setLotRequestFiles", response.data.requestFiles ?? []);
                    commit("setSuccess", response.data.status);
                    commit("setError", false);
                })
                .catch(err => {
                    commit("setSuccess", false);
                    commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
                    dispatch("fetchPublicLot", state.data.id);
                });
        },

        cancelUserRequest: ({commit, dispatch, state}) => {
            const url = "lots/" + state.data.id + "/cancelRequest";
            const data = {
                status: state.userLotRequest.status,
            };

            return axios
                .put(url, data)
                .then(response => {
                    commit("setUserLotRequest", response.data.request ?? {});
                    commit("setLotRequestFiles", response.data.requestFiles ?? []);
                    commit("setSuccess", response.data.status);
                    commit("setError", false);
                })
                .catch(err => {
                    commit("setSuccess", false);
                    commit("setError", err.response.data.message ?? e.message ?? "Неизвестная ошибка");
                    dispatch("fetchPublicLot", state.data.id);
                });
        },

        fetchCurrentLotTime: ({state}) => {
            const url = `/lots/${state.data.id}/time`;
            return axios.get(url);
        },

        tradeCancel: ({dispatch, state}) => {
            let url = `/admin/auctions/${state.data.id}/tradeCancel`;
            return axios.post(url).then(() => {
                dispatch("fetchLot", state.data.id);
            });
        },

        tradeSuspend: ({dispatch, state}) => {
            let url = `/admin/auctions/${state.data.id}/tradeSuspend`;
            return axios.post(url).then(() => {
                dispatch("fetchLot", state.data.id);
            });
        },

        auctionMarkDraft: ({dispatch, state}) => {
            let url = `/admin/auctions/${state.data.id}/auctionMarkDraft`;
            return axios.post(url).then(() => {
                dispatch("fetchLot", state.data.id);
            });
        },

        tradeReset: ({dispatch, state}, {start_date, start_time}) => {
            let url = `/admin/auctions/${state.data.id}/tradeReset`;
            return axios.post(url, {
                start_date,
                start_time,
            }).then(() => {
                dispatch("fetchLot", state.data.id);
            });
        },

        tradeFinish: ({dispatch, state}, {winner_id, sum, finish_date, finish_time}) => {
            let url = `/admin/auctions/${state.data.id}/tradeFinish`;
            return axios
                .post(url, {
                    winner_id,
                    sum,
                    finish_date,
                    finish_time
                })
                .then(() => {
                    dispatch("fetchLot", state.data.id);
                });
        },

        tradeDidNotTakePlace: ({dispatch, state}, {reason, finish_date, finish_time}) => {
            let url = `/admin/auctions/${state.data.id}/tradeDidNotTakePlace`;
            return axios
                .post(url, {
                    reason,
                    finish_date,
                    finish_time
                })
                .then(() => {
                    dispatch("fetchLot", state.data.id);
                });
        },

        socketUnavailable: ({commit}) => {
            commit("setSocketStatus", false);
        },

        socketAvailable: ({commit}) => {
            commit("setSocketStatus", true);
            commit("socketOnceConnected", true);
        },

        hallSign: ({commit}, {lotId, sign}) => {
            commit("setHallSign", {lotId, sign});
        },
    },
};
